{
  "companyInfoFields": {
    "required": "Enter the company name.",
    "max": "The company name must be 50 characters or fewer.",
    "required2": "Enter the phone number.",
    "phoneNumber": "Enter the phone number in a valid format.",
    "required3": "Enter the postal code.",
    "postalCode": "Enter the postal code in a valid format.",
    "required4": "Enter the prefecture.",
    "required5": "Enter the city.",
    "required6": "Enter the street address and building name.",
    "enqueueSnackbar": "Company information updated.",
    "enqueueSnackbar2": "The company information couldn't be updated.",
    "text": "Loading...",
    "alert": "The company information couldn't be loaded. Reload the page.",
    "label": "Company name",
    "label2": "Phone number",
    "label3": "Postal code",
    "label4": "Prefecture",
    "label5": "City",
    "label6": "Street address and building"
  },
  "samlFields": {
    "required": "The IdP entity ID is required.",
    "required2": "The IdP SSO endpoint URL is required.",
    "matches": "Enter a URL that starts with https://.",
    "url": "The URL format is invalid.",
    "test": "Enter the value in the format -----BEGIN CERTIFICATE----- ... -----END CERTIFICATE-----.",
    "required3": "The email address attribute name is required.",
    "title": "Copy",
    "ariaLabel": "Copy {{label}}",
    "enqueueSnackbar": "{{label}} copied.",
    "enqueueSnackbar2": "The value couldn't be copied.",
    "message": "The IdP certificate is required.",
    "enqueueSnackbar3": "SSO settings saved.",
    "text": "The SSO settings couldn't be saved.",
    "alert": "The SSO settings couldn't be loaded. Reload the page.",
    "text2": "Enable SSO",
    "text3": "When enabled, SSO sign-in is available in addition to password sign-in. Configure MFA on the IdP side.",
    "text4": "Select your IdP (identity provider)",
    "text5": "Select the service you use to see input hints and default attributes.",
    "label": "IdP entity ID",
    "label2": "IdP SSO endpoint URL",
    "text6": "Registered. Paste a new PEM only to update the certificate (leave blank to keep the existing one)",
    "text7": "Download the IdP metadata XML, then paste the value inside <X509Certificate> wrapped in BEGIN/END lines",
    "label3": "IdP certificate (PEM)",
    "text8": "(Registered — enter only to change)",
    "text9": "Attribute mapping",
    "text10": "Enter the attribute names sent from the IdP. If you're not sure, keep the defaults.",
    "text11": "Used to identify users (required)",
    "label4": "Email address attribute name",
    "text12": "Example: email",
    "text13": "Treated as the last name (combined with the first name in advanced settings)",
    "text14": "Optional. Split into last and first name by a space",
    "text15": "Last name attribute name",
    "text16": "Display name attribute name",
    "text17": "Example: displayName",
    "button": "Advanced settings (when last and first names are sent as separate attributes)",
    "text18": "When set, the \"Display name attribute name\" is used as the last name and this value as the first name",
    "label5": "First name attribute name",
    "placeholder": "Example: http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname",
    "text19": "Register JIZAIPAD information in your IdP",
    "text20": "Copy the following values and paste them into the IdP settings screen.",
    "alert2": "The tenant information is loading, or the API origin (JIZAIPAD_API_URL) isn't set.",
    "label6": "SP entity ID",
    "label7": "ACS URL (callback URL)",
    "text21": "Email addresses are matched exactly.",
    "text22": "If the address differs between the IdP and JIZAIPAD, the same person is treated as a different account.",
    "text23": "Signing in to JIZAIPAD requires a user invitation. Email addresses that haven't been invited can't sign in, even with SSO.",
    "title2": "Register in your IdP",
    "text24": "SSO is enabled. Register the SP information below in your IdP."
  },
  "securityFields": {
    "label": "Enable for all",
    "label2": "Disable for all",
    "label3": "Set per account",
    "text": "Some security settings couldn't be updated.",
    "text2": "The security settings couldn't be updated.",
    "enqueueSnackbar": "Security settings updated.",
    "text3": "Verify identity by email address at sign-in",
    "text4": "When enabled, a verification code sent to the email address must be entered at sign-in",
    "text5": "Send a notification email to the account's email address at sign-in (protects against unauthorized sign-ins)",
    "text6": "Enabling or disabling for all applies the setting to every user in the company.",
    "label4": "Sign-in notification"
  },
  "securityForm": {
    "label": "Enable for all",
    "label2": "Disable for all",
    "label3": "Set per account",
    "enqueueSnackbar": "Security settings updated.",
    "enqueueSnackbar2": "The security settings couldn't be updated.",
    "enqueueSnackbar3": "Sign-in notification email settings updated.",
    "enqueueSnackbar4": "The sign-in notification email settings couldn't be updated.",
    "title": "Sign-in verification",
    "text": "Verify identity by email address at sign-in",
    "text2": "When enabled, a verification code sent to the email address must be entered at sign-in",
    "title2": "Sign-in notification email settings",
    "text3": "Send a notification email to the account's email address at sign-in (protects against unauthorized sign-ins)",
    "text4": "Enabling or disabling for all applies the setting to every user in the company.",
    "label4": "Sign-in notification"
  },
  "companySettings": {
    "label": "General",
    "label2": "Security",
    "label3": "SSO settings",
    "title": "Company settings",
    "text": "Updating...",
    "title2": "Company information"
  },
  "samlIdpTemplates": {
    "hint": "To use Microsoft Entra ID (formerly Azure AD), create an enterprise application and set up SAML SSO. The entity ID and SSO URL are available in the \"Federation Metadata XML\".",
    "entityIdHint": "Azure portal → Enterprise applications → SAML → \"Identifier (Entity ID)\"",
    "ssoUrlHint": "Azure portal → Enterprise applications → SAML → \"Sign-in URL\"",
    "hint2": "To use Okta, in the Admin Console select \"Applications\" → \"Create App Integration\" → \"SAML 2.0\". Each value is available from the metadata URL or XML.",
    "entityIdHint2": "Okta Admin → app settings → Sign On → \"Identity Provider issuer\"",
    "ssoUrlHint2": "Okta Admin → app settings → Sign On → \"Identity Provider Single Sign-On URL\"",
    "hint3": "To use Google Workspace, in the Admin console select \"Apps\" → \"Web and mobile apps\" → \"Add custom SAML app\".",
    "entityIdHint3": "Google Admin console → Apps → SAML apps → \"Entity ID\"",
    "ssoUrlHint3": "Google Admin console → Apps → SAML apps → \"SSO URL\"",
    "label": "Other",
    "hint4": "Any IdP that supports SAML 2.0 can be used. Open the SAML settings page in your IdP's admin console and enter the following information.",
    "entityIdHint4": "The value shown as \"Issuer\" or \"Entity ID\" on the IdP's SAML settings screen",
    "ssoUrlHint4": "The value shown as \"SSO URL\" or \"Sign-in URL\" on the IdP's SAML settings screen"
  }
}
